/**
 * Model details for Address information.
 */
export class Address {
    entityId: number;
    id: number;
    houseNumber: string;
    street: string;
    zip: string;
    city: string;
    country: string;
    other: string;
    addressType: string;
    lat: number;
    lng: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/address.model.ts